var React = require('react');

function ArrowRightLight (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Component_3_1","data-name":"Component 3 – 1","transform":"translate(0 0.157)"},[React.createElement("path",{"id":"Path_16","data-name":"Path 16","d":"M130.693,4053l8.414,10.372-8.414,9.553","transform":"translate(-105.941 -4053)","fill":"none","stroke":"#b9b9b9","strokeWidth":"0.5","key":0}),React.createElement("line",{"id":"Line_18","data-name":"Line 18","x1":"32.495","transform":"translate(0 10.289)","fill":"none","stroke":"#b9b9b9","strokeWidth":"0.5","key":1})]));
}

ArrowRightLight.defaultProps = {"width":"33.493","height":"20.248","viewBox":"0 0 33.493 20.248"};

module.exports = ArrowRightLight;

ArrowRightLight.default = ArrowRightLight;
